import { ref } from 'vue'
import { useStore } from 'vuex'
import { getFile } from '@/crud.js'
import base from '@/plugins/exporter'
import { fitRdoPhotos } from '@/components/printTemplates/fitRdoPhotos'

export function useExport() {
  const exportLoader = ref(false)
  const store = useStore()

  const exportToXlsx = async (filters, action, file, routeName, content, includeDeleted) => {
    const config = base?.[action]

    if (!action || !config) {
      store?.dispatch('setError', 'Ação inválida ou configuração não encontrada.')
      return
    }

    const params = { filters }
    const headers = config.headers || []
    const fileName = file || config.title
    const route = config.route

    if (!route) {
      store?.dispatch('setError', 'Rota não definida para exportação.')
      return
    }

    exportLoader.value = true

    try {
      const result = await getFile(params, fileName, headers, route, routeName, content, includeDeleted)

      if (result.error) {
        store?.dispatch('setError', 'Não foi possível exportar o arquivo!')
      }
    } catch (err) {
      store.dispatch('setError', 'Erro inesperado ao exportar o arquivo.')
      console.error('Erro na exportação:', err)
    } finally {
      exportLoader.value = false
    }
  }

  // Garante que todas as imagens estejam carregadas antes de abrir a caixa de impressao,
  // senao o navegador imprime as fotos em branco.
  const waitForImages = (targetWindow, timeout = 15000) => {
    const images = Array.from(targetWindow.document.images || [])
    const pending = images.filter((image) => !image.complete)

    if (!pending.length) return Promise.resolve()

    return Promise.race([
      Promise.all(
        pending.map(
          (image) =>
            new Promise((resolve) => {
              image.addEventListener('load', resolve, { once: true })
              image.addEventListener('error', resolve, { once: true })
            }),
        ),
      ),
      new Promise((resolve) => setTimeout(resolve, timeout)),
    ])
  }

  const exportToPdf = async (templateFn) => {
    try {
      const htmlString = await templateFn()
      const blob = new Blob([htmlString], { type: 'text/html' })
      const url = URL.createObjectURL(blob)

      const newWindow = window.open(
        url,
        '_blank',
        'toolbar=no,location=no,status=no,menubar=no,resizable=yes,width=1000,height=1000'
      )

      if (!newWindow) {
        console.error('Falha ao abrir nova janela.')
        return
      }

      newWindow.onload = async () => {
        await waitForImages(newWindow)
        fitRdoPhotos(newWindow)
        newWindow.print()
        URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.log(error)
      return error
    }
  }

  return {
    exportLoader,
    exportToXlsx,
    exportToPdf,
  }
}
